// import Image from "next/image";
import { HeaderVariantImageGrid } from "./type";
import { CLink } from "../customLink/CustomLink";
import { getCloudinaryURL } from "@/utils/cloudinary";
import NoImageSrc from "@/assets/images/no_image.svg";
import { cn } from "@/lib/tailwind";
import { useEffect, useRef, useState } from "react";
import { useEditsChildWidth } from "@/hooks/useEditsChildWidth";
import CldImage from "@/components/ui/cldImg/CldImage";
import RenderCurrencyInText from "../RenderCurrencyInText";

const WithImageGrid = ({ images }: HeaderVariantImageGrid) => {
  const parentRef = useRef<HTMLDivElement | null>(null);
  const { isEditsCenter } = useEditsChildWidth(parentRef);

  return (
    <div className="container flex h-[9.688rem] w-full items-center justify-center sm:h-[17.75rem] md:px-12">
      <div
        ref={parentRef}
        className={cn(
          "no-scrollbar flex w-full items-center gap-[0.563rem] overflow-auto px-4 lg:gap-[0.875rem]",
          isEditsCenter ? "justify-center" : "justify-start",
        )}
      >
        {images?.map((c, i) => (
          <div
            key={i + c.label}
            className={cn(
              "flex flex-shrink-0 cursor-pointer items-center justify-center space-y-2",
              c.active ? "border-[1px] border-tertiary-13" : "",
            )}
            onClick={() => {
              if (c.handleSelectedEdits !== undefined && c.index !== undefined) {
                c.handleSelectedEdits(c.index);
              }
            }}
          >
            <CLink
              href={c?.url ?? ""}
              className="flex flex-col items-center justify-center gap-2 md:gap-4"
            >
              <div className="flex h-[8.188rem] w-[5.438rem] items-center justify-center md:h-[15.438rem] md:w-[13.25rem]">
                <CldImage
                  width={87}
                  src={getCloudinaryURL(c?.src) ?? NoImageSrc}
                  alt={c?.alt}
                  height={131}
                  className="h-[8.188rem] w-[5.438] object-cover md:h-[15.438rem] md:w-[13.25rem]"
                />
              </div>
              <h2 className="text-[0.75rem] font-medium md:text-base">
                <RenderCurrencyInText text={c?.label} />
              </h2>
            </CLink>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WithImageGrid;
